import React from 'react';
import PropTypes from 'prop-types';

const Card = ({ title, children }) => (
  <div className="panel card">
    <div className="panel-heading">
      <h3 className="panel-title">{title}</h3>
    </div>
    <div className="panel-body">
      {children}
    </div>
  </div>
);

Card.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Resource/components/Card.jsx